import React, { useEffect, useRef } from 'react';
import $ from 'jquery';
import 'summernote/dist/summernote-lite';
import 'summernote/dist/summernote-lite.css';

const SummernoteEditor = ({ value, onChange, height = 300 }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    if (!editorRef.current) return;

    const $editor = $(editorRef.current);

    $editor.summernote({
      height: height,
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link']],
        ['view', ['codeview', 'help']]
      ],
      callbacks: {
        onChange: function(contents) {
          if (onChange) {
            onChange(contents);
          }
        }
      }
    });

    // Set initial content
    $editor.summernote('code', value || '');

    // Cleanup on unmount
    return () => {
      $editor.summernote('destroy');
    };
  }, []);

  // Update content when value prop changes
  useEffect(() => {
    if (!editorRef.current) return;
    const $editor = $(editorRef.current);
    const currentContent = $editor.summernote('code');
    if (value !== currentContent) {
      $editor.summernote('code', value || '');
    }
  }, [value]);

  return (
    <div 
      ref={editorRef} 
      onClick={(e) => { if (e && e.stopPropagation) e.stopPropagation(); }}
      onFocus={(e) => { if (e && e.stopPropagation) e.stopPropagation(); }}
    />
  );
};

export default SummernoteEditor;
